<div class="topDiv">

  <div class="mainContent">

    <div style="height: 7vh;">
      <div>
        <label i18n="@@spmsUserReg" class="textColour">Manage MDL Script</label>
        <span class="example-spacer"></span>
      </div>
    </div>

    <div style="height: 67vh; overflow: auto; padding-left: 4%; padding-right: 4%;">
      <form novalidate [formGroup]="FormValid" style="width: 100%;">

        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>Property Category</mat-label>
              <mat-select formControlName="propertycategory" [(ngModel)]="mdlscript.propertycategory"
                (selectionChange)="onPropertyCategoryChange($event)">
                <mat-option *ngFor="let data of JsuiteCategoryData" [value]="data">
                  {{data}}
                </mat-option>

              </mat-select>
              <mat-error *ngFor="let validation of
                  validation_messages.propertycategory">
                <span *ngIf="FormValid.get('propertycategory').hasError(validation.type)
                    && (FormValid.get('propertycategory').dirty ||
                    FormValid.get('propertycategory').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>Property Name</mat-label>
              <mat-select formControlName="propertyname" placeholder="Property Name"
                (selectionChange)="onpropertyChange($event)">
                <mat-option *ngFor="let data of propertyData" [value]="data.propertyname">
                  {{data.propertyname}}
                </mat-option>

              </mat-select>
              <mat-error *ngFor="let validation of
                  validation_messages.propertyname">
                <span *ngIf="FormValid.get('propertyname').hasError(validation.type)
                    && (FormValid.get('propertyname').dirty ||
                    FormValid.get('propertyname').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>

            </mat-form-field>
          </div>
        </div>



        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>Component Type</mat-label>
              <mat-select formControlName="component_type" placeholder="Component Type"
                [(ngModel)]="mdlscript.component_type" (selectionChange)="onComponentTypeChange($event)">
                <mat-option *ngFor="let data of componentTypeData" [value]="data">
                  {{data}}
                </mat-option>

              </mat-select>
              <mat-error *ngFor="let validation of
                  validation_messages.component_type">
                <span *ngIf="FormValid.get('component_type').hasError(validation.type)
                    && (FormValid.get('component_type').dirty ||
                    FormValid.get('component_type').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>


            </mat-form-field>
          </div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>Execution Order</mat-label>
              <input matInput type="text" formControlName="executionorder" placeholder="Execution Order"
                [(ngModel)]="mdlscript.executionorder">
                            <mat-error *ngFor="let validation of
                  validation_messages.executionorder">
                <span *ngIf="FormValid.get('executionorder').hasError(validation.type)
                    && (FormValid.get('executionorder').dirty ||
                    FormValid.get('executionorder').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>


            </mat-form-field>
          </div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>MDL Template Create</mat-label>
              <textarea matInput type="text" placeholder="MDL Template Create" formControlName="createmdltemplate"
                [(ngModel)]="mdlscript.createmdltemplate"></textarea>
              <mat-error *ngFor="let validation of
                  validation_messages.createmdltemplate">
                <span *ngIf="FormValid.get('createmdltemplate').hasError(validation.type)
                    && (FormValid.get('createmdltemplate').dirty ||
                    FormValid.get('createmdltemplate').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>

            </mat-form-field>
          </div>
        </div>

        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline">
              <mat-label>MDL Template Update</mat-label>
              <textarea matInput type="text" placeholder="MDL Template Update" formControlName="updatemdltemplate"
                [(ngModel)]="mdlscript.updatemdltemplate"></textarea>
              <mat-error *ngFor="let validation of
                  validation_messages.updatemdltemplate">
                <span *ngIf="FormValid.get('updatemdltemplate').hasError(validation.type)
                    && (FormValid.get('updatemdltemplate').dirty ||
                    FormValid.get('updatemdltemplate').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>

            </mat-form-field>
          </div>
        </div>


        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <div class="radio-group-container">
              <mat-checkbox class="example-margin" formControlName="isexecutable" [(ngModel)]="mdlscript.isexecutable"
                (change)="updateCheckbox($event)"></mat-checkbox>
              <label>Is Executable</label>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer Buttons -->
    <div style="height: 1vh;">
      <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%; ">
        <div class="col-lg text-center" style="margin-top: -15px;padding-top: 50px;">
          <div style="text-align: end; ">
            <form novalidate [formGroup]="formValidCheckbox">
              <span *ngIf="showCreateAnother">
                <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected"
                  style="margin-right:1%" class="mat-checkbox-layout"></mat-checkbox>
                <span>Create another</span>
              </span>

              <button i18n="@@TargetClear" type="button"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="backgroundColorButton" (click)="saveMethod()"
                style="padding: .3rem 1.6rem; font-size: .85rem; width:150px; color: white;">
                {{this.buttonName}}
              </button>

              <button i18n="@@TargetCancel" type="button"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" (click)="cancel()"
                [style.background-color]="backgroundColorButton"
                style="padding: .3rem 1.6rem; font-size: .85rem; width:150px; color: white;">Cancel</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>